import { PRODUCT_TYPE } from '../../common/constants/productType'

export enum EmailCaptureV2ArmType {
  CONTROL = 'control',
  EXPERIMENT_A = 'experiment A',
  EXPERIMENT_B = 'experiment B',
}

export enum EmailCaptureV2Metric {
  VIEW_PAGE = 'view email capture page',
  CLICK_CONTINUE = 'click continue',
  CLICK_CONTINUE_WITH_GOOGLE = 'click continue with google',
  CLICK_CONTINUE_WITH_APPLE = 'click continue with apple',
}

export enum EmailCaptureV2Description {
  VIEW_PAGE = 'user lands on email capture page',
  CLICK_CONTINUE = 'user clicks continue to submit email address',
  CLICK_CONTINUE_WITH_GOOGLE = 'user clicks continue with google to submit email address using google',
  CLICK_CONTINUE_WITH_APPLE = 'user clicks continue with apple to submit email address using apple',
}

export interface EmailCaptureExperimentV2JoinKeys {
  customer_name: string
  customer_product_type: PRODUCT_TYPE
  description: string
  device_uuid: string
  metric: EmailCaptureV2Metric
}

export interface EmailCaptureExperimentV2PayloadParams {
  arm: EmailCaptureV2ArmType
  deviceUUID: string
  customerName: string
  productType: PRODUCT_TYPE
  description: string
  metric: EmailCaptureV2Metric
}
